import { Type } from "class-transformer";
import { EventReminderInfo } from "./EventReminderInfo";

export class ProjectPersonalSummary {
    overdueCount = 0;
    todayTasksCount = 0;
    todayAppointmentsCount = 0;
    @Type(() => EventReminderInfo)
    reminder: EventReminderInfo[];
}
